export const LOGIN_PATH = '/login';

// Private paths
export const HOME_PATH = '/clientes';
export const GRUPOS_LIST_PATH = '/grupos';
export const CREATE_GROUP_PATH = '/grupos/novo';
export const EDIT_GROUP_PATH = '/grupos/:clientId/editar';
export const LEADS_LIST_PATH = '/leads';
export const CREATE_PROPOSAL_PATH = '/criar-proposta';
export const COMMERCIAL_GROUP_PATH = '/cliente/:groupId';
export const LEAD_GROUP_PATH = '/lead/:groupId';
export const UNITS_PATH = 'unidades';
export const CREATE_UNIT_PATH = '/nova-unidade';
export const EDIT_UNIT_PATH = '/:unitId/editar-unidade';
export const COMMERCIAL_GROUPS_USERS_PATH = 'usuarios';
export const KICK_OFF_PATH = 'kick-off';
export const TRADERS_PATH = '/fornecedoras';
export const TRADERS_USERS_PATH = 'usuarios';
export const TRADERS_PROFILE_CCEE_PATH = 'perfis-ccee';
export const TRADER_DETAIL_PATH = '/fornecedoras/:traderId';
export const USERS_PATH = '/usuarios';
/** Grupos, perfis e permissões da Authorization Extension do Auth0. */
export const AUTH0_AUTHZ_PATH = USERS_PATH;
export const GROUPS_PROFILES_PATH = '/grupos-e-perfis';
export const USERS_EMAIL_LOG_PATH = ':userId/emails';
export const CONTRACTS_PATH = '/contratos';
export const MANAGEMENT_CONTRACTS_PATH = '/contratos-de-vendas';
export const ENERGY_CONTRACTS_PATH = '/contratos-energia';
/** Listagens que eram abas de /contratos-energia. */
export const CCEE_CONTRACTS_PATH = '/contratos-ccee';
export const PROINFA_CONTRACTS_PATH = '/proinfa';
/** Listagem de contratos lida do clarke-contract (superadmin, pré-tombamento). */
export const CONTRACTS_V2_PATH = '/contratos-novo';
export const CONTRACTS_V2_CREATE_PATH = '/contratos-novo/criar';
export const CONTRACTS_V2_EDIT_PATH = '/contratos-novo/:contractId/editar';
/** Cadastro de Contrato de Gestão -- listagem e formulário próprios. */
export const CONTRACTS_V2_MANAGEMENT_PATH = '/contratos-novo/gestao';
export const CONTRACTS_V2_MANAGEMENT_CREATE_PATH = '/contratos-novo/gestao/criar';
export const CONTRACTS_V2_MANAGEMENT_EDIT_PATH = '/contratos-novo/gestao/:contractId/editar';
/** Preview em nova aba (PDF/imagem) — `docKey` = `signed` ou id do anexo. */
export const CONTRACTS_V2_MANAGEMENT_FILE_PATH = '/contratos-novo/gestao/:contractId/arquivo/:docKey';
/** Preview do CCEAL em nova aba — mesmo padrão do preview de gestão. */
export const CONTRACTS_V2_ENERGY_FILE_PATH = '/contratos-novo/:contractId/arquivo';
export const CREATE_ENERGY_CONTRACT_PATH = '/novo-contrato-energia';
export const EDIT_ENERGY_CONTRACT_PATH = '/:contractId/editar-contrato-energia';
export const CREATE_CCEE_CONTRACT_PATH = '/novo-contrato-ccee';
export const EDIT_CCEE_CONTRACT_PATH = '/:id/editar-contrato-ccee';
export const CREATE_CLARKE_CONTRACT_PATH = '/novo-contrato-clarke';
export const EDIT_CLARKE_CONTRACT_PATH = 'editar-contrato-clarke/:nestedContractId';
export const CHURN_CLARKE_CONTRACT_PATH = 'churn-contrato-clarke/:contractId';
export const CREATE_PROINFA_CONTRACT_PATH = '/novo-contrato-proinfa';
export const CREATE_MCP_PATH = '/novo-contrato-curto-prazo';
export const EDIT_MCP_PATH = ':contractId/editar-contrato-curto-prazo';
export const CREATE_MCP_CONTRACT_PATH = '/novo-contrato-mcp';
export const EDIT_MCP_CONTRACT_PATH = '/editar-contrato-mcp/:contractId';
export const CREATE_CROSS_SELLING_CONTRACT_PATH = '/novo-contrato-cross-selling';
export const EDIT_CROSS_SELLING_CONTRACT_PATH = '/editar-contrato-cross-selling/:contractId';
export const CCEE_PROFILES_PATH = '/perfis';
export const TAKE_RATE_PANEL = '/painel-de-take-rate';
export const ENERGY_INVOICES_PATH = '/notas-fiscais';
export const TAKE_RATE_SUPPLIER_DETAIL = '/painel-de-take-rate/fornecedor/:supplierId';
export const EDIT_TAKE_RATE_BY_TRADER_PATH = '/editar-take-rate-fornecedora/:invoiceId';
export const EDIT_TAKE_RATE_BY_CLIENT_PATH = '/painel-de-take-rate/fornecedor/:supplierId/editar-cliente/:clientId';

export const DOCUMENTS_PATH = 'documentos';
export const UNIT_REPORT_PATH = '/relatorio-unidade/:reportId';
export const GROUP_REPORT_PATH = '/relatorio-grupo/:id';
export const FINANCIAL_EVENTS_PATH = '/eventos-financeiros';
export const NEW_FINANCIAL_EVENT_PATH = '/eventos-financeiros/novo';
export const ENERGY_AUDIT_PATH = '/balanco-energetico';
export const UPLOAD_MEASUREMENT_PATH = '/upload-medicao';
export const DEVEC_PATH = '/devec';
export const UPSERT_UNIT_PATH = 'unidades/:upsertUnit/:unitId';
export const MIGRATION_REPORT_PATH = '/relatorios-migracao';
export const MIGRATION_PANEL_PATH = '/painel-de-migracao';
export const MANAGEMENT_RECEIVABLES_PATH = '/recebiveis-de-gestao';
export const CLARKE_CONTRACT_PATH = '/contrato-clarke';
export const RECORD_PAYMENTS_PATH = '/registro-de-pagamentos';
export const CONSOLIDATED_PAYMENTS_PATH = '/pagamentos-consolidados';
export const EDIT_RECEIVABLE_PATH = '/editar-recebivel/:contractId';
export const ENERGY_CONTRACT_PATH = '/contrato-energia';
export const CS_CONTRACT_PATH = '/contrato-cross-selling';
export const CP_CONTRACT_PATH = '/contrato-curto-prazo';
export const TAXES_PATH = '/impostos';
export const INVOICES_DISTRIBUTION_PATH = '/faturas/distribuicao';
export const INVOICES_DISTRIBUTION_OCR_PATH = '/faturas/distribuicao/ocr';
export const INVOICES_DISTRIBUTION_FILE_PATH = '/faturas/distribuicao/arquivo/:fileId';
export const INVOICES_SUPPLY_PATH = '/faturas/fornecimento';
// Economy Report Paths
export const CREATE_ECONOMY_REPORT_PATH = '/relatorio-economia/novo';
export const EDIT_ECONOMY_REPORT_PATH = '/relatorio-economia/editar';
export const ECONOMY_REPORT_PATH = '/relatorios-economia';

// MANAGEMENT CONTRACTS
export const MANAGEMENT_CONTRACTS__CLARKE_RETAILER__PATH = '/contratos-clarke-varejo';
export const MANAGEMENT_CONTRACTS__CLARKE_MANAGEMENT__PATH = '/contratos-clarke-gestao';
export const MANAGEMENT_CONTRACTS_UPDATE_PATH = 'atualizar/:contractId';
export const MANAGEMENT_CONTRACTS_CHURN_PATH = 'churn/:contractId';
export const MANAGEMENT_CONTRACTS_REQUEST_MODE_PATH = 'novo-contrato';

// Financial Events V2
export const FINANCIAL_EVENTS_V2_PATH = '/eventos-financeiros-v2';
export const FINANCIAL_EVENTS_V2_TYPE_PATH = '/eventos-financeiros-v2/:eventType';
export const FINANCIAL_EVENTS_V2_GUARANTEE_PATH = '/eventos-financeiros-v2/garantia-financeira';
export const FINANCIAL_EVENTS_V2_SETTLEMENT_PATH = '/eventos-financeiros-v2/liquidacao-financeira';
export const FINANCIAL_EVENTS_V2_RESERVE_ENERGY_PATH = '/eventos-financeiros-v2/encargo-energia-reserva';
export const FINANCIAL_EVENTS_V2_ASSOCIATIVE_PATH = '/eventos-financeiros-v2/contribuicao-associativa';
export const FINANCIAL_EVENTS_V2_CAPACITY_RESERVE_PATH = '/eventos-financeiros-v2/energia-reserva-capacidade';
export const FINANCIAL_EVENTS_V2_NUCLEAR_PATH = '/eventos-financeiros-v2/cotas-energia-nuclear';
export const FINANCIAL_EVENTS_V2_SEND_PANEL_PATH = '/eventos-financeiros-v2/:eventType/painel-envio';
export const FINANCIAL_EVENTS_V2_ROUND_DETAIL_PATH = '/eventos-financeiros-v2/:eventType/painel-envio/:roundId';
export const FINANCIAL_EVENTS_V2_CREATE_PATH = '/eventos-financeiros-v2/:eventType/novo';
export const FINANCIAL_EVENTS_V2_APORTE_PATH = '/eventos-financeiros-v2/:eventType/novo-aporte';

// Unit X-Ray
// UNIT_XRAY_PATH is the suffix composed with /grupo|matriz|filial/:companyId.
// UNIT_XRAY_STANDALONE_PATH is the canonical standalone form for callers that
// don't carry companyId in scope (the page derives companyId from the unit).
export const UNIT_XRAY_PATH = '/:unitId/raio-x';
export const UNIT_XRAY_STANDALONE_PATH = '/unidades/:unitId/raio-x';
export const RAIO_X_PANEL_PATH = '/raio-x';
export const RAIO_X_DEMAND_LIST_PATH = '/raio-x/ajuste-demanda';
export const RAIO_X_MODALITY_LIST_PATH = '/raio-x/ajuste-modalidade';
export const RAIO_X_ENERGY_TYPE_LIST_PATH = '/raio-x/ajuste-tipo-energia';
export const CLIENT_PORTFOLIO_PATH = '/carteira';
export const DETAILED_ENERGY_AUDIT_PATH = '/auditoria-energetica/:id';
export const MEASUREMENT_BY_UNIT_PATH = '/auditoria-energetica/:id/medicao';

// Uma empresa (Sobre a empresa) e o grupo econômico (Sobre o Grupo Econômico).
// O grupo é o client, então a rota do grupo é chaveada por clientId — não por
// company. hierarchyLevel não escolhe mais rota: uma empresa GE que pertence ao
// client de outro grupo é empresa, não grupo.
export const COMPANY_DETAILS_PATH = '/empresa/:companyId';
export const GROUP_DETAILS_PATH = '/grupo/:clientId';
// Raio-X do Cliente: o "grupo econômico" da interface é o ClarkeClient do
// backend, então a rota é chaveada por clientId — mesma convenção de
// GROUP_DETAILS_PATH.
export const CLIENT_XRAY_PATH = '/grupo/:clientId/raio-x';
export const CREATE_CUSTOMER_PATH = '/clientes/novo';
export const CREATE_LEAD_PATH = '/leads/novo';
export const EDIT_CUSTOMER_PATH = '/clientes/:id/editar';
export const EDIT_LEAD_PATH = '/leads/:id/editar';

// Demand Adjustment
// UNIT_DEMAND_ADJUSTMENT_PATH is the suffix composed with /cliente/:groupId/unidades.
// UNIT_DEMAND_ADJUSTMENT_STANDALONE_PATH is the canonical standalone form for callers
// that don't carry groupId/companyId in scope (mirrors UNIT_XRAY_STANDALONE_PATH).
export const UNIT_DEMAND_ADJUSTMENT_PATH = '/:unitId/ajuste-demanda';
export const UNIT_DEMAND_ADJUSTMENT_STANDALONE_PATH = '/unidades/:unitId/ajuste-demanda';

// Modality Adjustment
export const UNIT_MODALITY_ADJUSTMENT_PATH = '/:unitId/ajuste-modalidade';
export const UNIT_MODALITY_ADJUSTMENT_STANDALONE_PATH = '/unidades/:unitId/ajuste-modalidade';

// Energy Type Adjustment
export const UNIT_ENERGY_TYPE_ADJUSTMENT_PATH = '/:unitId/ajuste-tipo-energia';
export const UNIT_ENERGY_TYPE_ADJUSTMENT_STANDALONE_PATH = '/unidades/:unitId/ajuste-tipo-energia';

// Analysis Print (no layout)
export const UNIT_MODALITY_PRINT_STANDALONE_PATH = '/unidades/:unitId/ajuste-modalidade/imprimir';
export const UNIT_ENERGY_TYPE_PRINT_STANDALONE_PATH = '/unidades/:unitId/ajuste-tipo-energia/imprimir';

// Tariffs
export const TARIFF_PROJECTIONS_PATH = '/tarifas/projecoes';

// Marketplace
export const MARKETPLACE_QUOTATIONS_PATH = '/cotacoes';
export const MARKETPLACE_QUOTATIONS_NEW_PATH = '/cotacoes/nova-solicitacao';
export const MARKETPLACE_ADD_PROPOSAL_PATH = '/cotacoes/:quotationId/adicionar-proposta';
export const MARKETPLACE_EDIT_PROPOSAL_PATH = '/cotacoes/:quotationId/editar-proposta/:proposalId';
export const MARKETPLACE_NEW_ROUND_PATH = '/cotacoes/:quotationId/nova-rodada';
export const MARKETPLACE_COMPILADO_PATH = '/cotacoes/:quotationId/compilado';
export const MARKETPLACE_COMPILADO_PUBLIC_PATH = '/compilado/:roundId';
// Calculation constants
export const CALCULATION_CONSTANTS_INDICATIVE_PRICES_PATH = '/constantes-de-calculo/precos-indicativos';
export const CALCULATION_CONSTANTS_IPCA_PATH = '/constantes-de-calculo/inflacao';
export const CALCULATION_CONSTANTS_TAX_RATES_PATH = '/constantes-de-calculo/aliquotas';
export const CALCULATION_CONSTANTS_CALCULATION_BASE_PATH = '/constantes-de-calculo/base-de-calculo';
export const CALCULATION_CONSTANTS_TARIFF_FLAGS_PATH = '/constantes-de-calculo/bandeiras-tarifarias';
export const CALCULATION_CONSTANTS_PRICE_AND_PRODUCT_PATH = '/constantes-de-calculo/preco-e-produto';
export const CALCULATION_CONSTANTS_PRICE_AND_PRODUCT_CREATE_PATH = '/constantes-de-calculo/preco-e-produto/adicionar';
export const CALCULATION_CONSTANTS_PRICE_AND_PRODUCT_EDIT_PATH =
  '/constantes-de-calculo/preco-e-produto/:productId/editar';
export const CALCULATION_CONSTANTS_PRICE_PREMISES_EDIT_PATH = '/constantes-de-calculo/preco-e-produto/premissas/editar';
export const CALCULATION_CONSTANTS_CHARGES_PATH = '/constantes-de-calculo/encargos';
export const CALCULATION_CONSTANTS_PLD_PATH = '/constantes-de-calculo/pld';
export const CALCULATION_CONSTANTS_DISTRIBUTION_TARIFFS_PATH = '/constantes-de-calculo/tarifas-de-distribuicao';
export const CALCULATION_CONSTANTS_TARIFF_VERSIONS_PATH = '/constantes-de-calculo/comparativo-de-versoes-tarifarias';

// Unidades Consumidoras
export const UNITS_CONSUMIDORAS_PATH = '/unidades-consumidoras';
export const UNITS_CONSUMIDORAS_CREATE_UNIT_PATH = UNITS_CONSUMIDORAS_PATH + CREATE_UNIT_PATH;

// 404
export const DOES_NOT_EXIST_PATH = '/does-not-exist';

export const SALES_SIMULATOR_PATH = '/simulador-de-vendas';
export const SALES_SIMULATOR_ML_PATH = `${SALES_SIMULATOR_PATH}/mercado-livre`;
export const SALES_SIMULATOR_ML_NEW_SIMULATION_PATH = `${SALES_SIMULATOR_ML_PATH}/nova-simulacao`;
export const SALES_SIMULATOR_ML_LEAD_PATH = `${SALES_SIMULATOR_ML_PATH}/lead/:leadId`;
export const SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH = `${SALES_SIMULATOR_ML_PATH}/contrato`;
export const SALES_SIMULATOR_GD_PATH = `${SALES_SIMULATOR_PATH}/geracao-distribuida`;
export const SALES_SIMULATOR_GD_NEW_SIMULATION_PATH = `${SALES_SIMULATOR_GD_PATH}/nova-simulacao`;
export const SALES_SIMULATOR_GD_RESULT_PATH = `${SALES_SIMULATOR_GD_PATH}/simulacao/:id`;

export const PUBLIC_PROPOSAL_PATH = '/proposta/:simulationId';
export const PUBLIC_SIMPLIFIED_PROPOSAL_PATH = '/proposta-simplificada/:simulationId';
export const PUBLIC_DETAILED_ANALYSIS_PATH = '/analise-detalhada/:simulationId';
export const PUBLIC_GD_PROPOSAL_PATH = '/geracao-distribuida/proposta/:id';
export const PUBLIC_GD_PROPOSAL_DOCUMENT_PATH = '/geracao-distribuida/proposta/:id/documento';
